/**
*功能: 登录
*/
<template>
  <div class="login">
    <div class="loginContainer">
      <div class="header">
        <img src="../../assets/img/login/logo.png" class="IconImg" alt=""/>
        <span v-if="$route.name === 'servicelogin'">天津渤化ERP系统</span>
        <span v-else>天津渤化客户服务系统</span>
        <div class="dotAnimation"></div>
      </div>
      <div class="inputContainer">
        <div class="inputItem ">
          <input v-model="loginForm.userName" autocomplete="on" placeholder="请输入用户名"/>
        </div>
        <div class="inputItem pwd">
          <input type="password" v-model="loginForm.password" @keyup="keysignIn($event)" placeholder="请输入密码"/>
        </div>
        <div class="loginBtn inputItem" :loading="loading" @click="signIn">
          登录
        </div>
      </div>
    </div>
    <div class="animation1">
      <img src="../../assets/img/login/1.png" alt=""/>
      <img src="../../assets/img/login/2.png" alt=""/>
      <img src="../../assets/img/login/3.png" alt=""/>
      <img src="../../assets/img/login/4.png" alt=""/>
      <img src="../../assets/img/login/5.png" alt=""/>
    </div>
    <div class="animation2"></div>
    <div class="animation3"></div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import storageM from '@/storage';

  const storage = storageM['localStorage'];

  export default {
    name: 'login',
    data() {
      return {
        loginForm: {
          userName: storage.$get({key: 'userName',}),
          password: '',
          isRemember: true,
        },
        loginRules: {
          userName: [
            {
              required: true,
              trigger: 'blur',
              message: '请输入用户名！',
            },
          ],
          password: [
            {
              required: true,
              trigger: 'blur',
              message: '请输入密码！',
            },
          ],
        },
        passwordType: 'password',
        loading: false,
        showDialog: false,
      };
    },
    mounted() {
      this.getRememberStatus();
      if (this.$route.name === 'servicelogin') {
        document.title = '客服服务系统'
      }
      else {
        document.title = '天津渤化客户服务系统'
      }
    },
    methods: {
      ...mapActions({
        setUserInfor: 'user/setUserInfor',
        setIsRemember: 'user/setIsRemember',
        removeIsRemember: 'user/removeIsRemember',
        setUpdatePassword: 'user/setUpdatePassword',
      }),
      ...mapGetters({
        getIsRemember: 'user/getIsRemember',
      }),
      getKeyIv() {
        this.$services.getU({
          type: 'LOGIN',
          url: 'getEncryptInfo',
        }).then(keyIv => {
          this.loading = false;
          this.$utils.setStorage({
            type: 'localStorage',
            key: 'getEncryptInfo',
            parameter: keyIv,
          });
          if (keyIv.status) {
            let {encryptIv, encryptKey} = keyIv.bean;
            let keyPassWord = this.$utils.crypto.CryptoString(
              this.loginForm.password,
              encryptKey,
              encryptIv,
            );
            this.$services.post({
              type: 'LOGIN',
              url: 'login',
              params: {
                accountId: 'Ourway',
                userName: this.loginForm.userName,
                password: keyPassWord,
                autoLogin: '0',
              },
            }).then(login => {
              if (login.status) {
                login.code === '000' ? this.$toaster.ok(login.msg) : this.$toaster.error(login.msg);
                // 将token设置请求头
                this.$services.setHeader({
                  key: 'TOKEN',
                  parameter: login.bean.tokenId,
                });
                // 将token存入localstorage
                this.$utils.setToken({
                  key: 'TOKEN',
                  parameter: login.bean.tokenId,
                });
                // 将用户信息存入vuex
                this.setUserInfor(login.bean.loginUserBean);
                // 判断用户是否记住密码
                if (this.loginForm.isRemember) {
                  storage.$set({key: 'userName', parameter: this.loginForm.userName,});
                  // storage.$set({ key: 'password', parameter: this.loginForm.password, });
                }
                else {
                  this.removeIsRemember();
                }
                this.setUpdatePassword(login.bean.loginUserBean.passwordModifyDate ? false : true)
                // 登陆跳转
                if (this.$route.query.redirect) {
                  this.$router.push(this.$route.query.redirect);
                }
                else {
                  let type = login.bean.loginUserBean.userType;
                  if (type === '0') {
                    document.title = '客服服务系统'
                  }
                  else {
                    document.title = '天津渤化客户服务系统'
                  }
                  this.$router.push('/');
                  // if (type === '0') {
                  //   this.$router.push({name: 'billLading'});
                  // }
                  // else {
                  //   this.$router.push({name: 'adminCurrentInventory'});
                  // }
                }
              }
              else {
                this.$toaster.error(login.msg);
              }
            });
          }
          else {
            this.$toaster.error(keyIv.msg);
          }
        });
      },
      showPwd() {
        if (this.passwordType === 'password') {
          this.passwordType = '';
        }
        else {
          this.passwordType = 'password';
        }
      },
      keysignIn(ev) {
        if (ev.keyCode === 13) {
          this.signIn();
        }
      },
      signIn() {
        if (this.loginForm.password && this.loginForm.userName) {
          this.loading = true;
          this.getKeyIv();
        }
        else {
          this.$message({
            message: '请填写用户名密码！',
            type: 'warning'
          });
          return false;
        }
      },
      getRememberStatus() {
        if (this.getIsRemember()) {
          this.loginForm = this.getIsRemember();
          console.log(this.loginForm);
        }
      },
    },
  };
</script>

<style rel="stylesheet/scss" lang="scss">
  $mainColor: #0d82c1;
  $mainColor1: #d4ecf7;
  $mainColor2: #e6f3f9;

  .clearfix:after {
    content: '.';
    /*加一段内容*/
    display: block;
    /*让生成的元素以块级元素显示，占满剩余空间*/
    height: 0;
    /*避免生成的内容破坏原有布局高度*/
    clear: both;
    /*清除浮动*/
    visibility: hidden;
    /*让生成的内容不可见*/
  }

  .clearfix {
    zoom: 1;
    /*为IE6，7的兼容性设置*/
  }

  input {
    background: none;
    outline: none;
    border: none;
    display: inline-block;
  }

  .IconImg {
    display: inline-block;
  }

  ul {
    list-style: none;
  }

  .iconImg {
    width: 1.3em;
    margin: 0 3px -3px 3px;
    display: inline-block;
  }

  .login {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    $itemHeight: 38px;

    .loginContainer {
      z-index: 1;
      display: inline-block;
      width: 350px;
      height: 400px;
      background: url("../../assets/img/login/bg1.png");
      background-size: 100% 100%;
      margin-top: 15vh;
      position: relative;

      .header {
        background: url("../../assets/img/login/bg2.png");
        background-size: 100% 100%;
        height: $itemHeight+12px;
        width: 393px;
        position: absolute;
        top: 20px;
        left: -20px;
        padding-top: 10px;
        color: white;
        font-size: 20px;
        line-height: $itemHeight+12px;

        img {
          height: 30px;
          margin-right: 8px;
        }

        .dotAnimation {
          position: absolute;
          background: url("../../assets/img/login/dot.png");
          background-size: 100% 100%;
          width: 100px;
          height: 54px;
          top: $itemHeight;
          animation: dotMove 2s linear 0s infinite alternate;
          @keyframes dotMove {
            from {
              left: -10px;
            }
            to {
              left: 300px;
            }
          }
        }
      }

      .inputContainer {
        text-align: center;
        position: relative;
        top: 120px;
      }

      .inputItem {
        background: url("../../assets/img/login/user.png");
        background-size: 100% 100%;
        width: 260px;
        height: $itemHeight;
        display: inline-block;
        position: relative;
        margin: 6px 0;

        input {
          height: $itemHeight;
          width: 215px;
          position: absolute;
          right: 0;
          color: #104b8a;
        }
      }

      .pwd {
        background: url("../../assets/img/login/pasword.png");
        background-size: 100% 100%;
      }

      .loginBtn {
        color: white;
        background: url("../../assets/img/login/login1.png");
        background-size: 100% 100%;
        line-height: $itemHeight;
        margin-top: 20px;
      }
    }

    .animation1 {
      position: absolute;
      top: 40vh;
      background: url("../../assets/img/login/line.png") repeat-x;
      background-size: 100% 100%;
      width: 100%;
      left: 0;
      right: 0;
      height: 68px;

      img {
        position: absolute;
        height: 99%;
        @keyframes iconMove {
          0% {
            left: -2vw;
            height: 96%;
            top: 2%;
          }
          50% {
            left: 50vw;
            height: 50%;
            top: 25%;
          }
          100% {
            left: 102vw;
            height: 96%;
            top: 2%;
          }
        }
        $animationTime: 10s;
        $interval: 2s;

        &:nth-child(1) {
          animation: iconMove $animationTime linear 0s infinite normal;
        }

        &:nth-child(2) {
          animation: iconMove $animationTime linear 1*$interval infinite normal;
        }

        &:nth-child(3) {
          animation: iconMove $animationTime linear 2*$interval infinite normal;
        }

        &:nth-child(4) {
          animation: iconMove $animationTime linear 3*$interval infinite normal;
        }

        &:nth-child(5) {
          animation: iconMove $animationTime linear 4*$interval infinite normal;
        }
      }
    }

    .animation2 {
      position: absolute;
      background: url("../../assets/img/login/line2.png");
      background-size: 100% 100%;
      height: 100vh;
      width: 100%;
      top: 0;
      right: 0;
      transform: rotate(10deg);
      animation: lineTransform 10s linear 0s infinite alternate;
      @keyframes lineTransform {
        0% {
          transform: rotate(10deg);
        }
        50% {
          transform: rotate(35deg);
        }
        100% {
          transform: rotate(60deg);
        }
      }
    }

    .animation3 {
      background: url("../../assets/img/login/bg.png") no-repeat;
      background-size: 100% 100%;
      height: 100%;
      animation: holeBG 10s linear 0s infinite alternate;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      @keyframes holeBG {
        0% {
          transform: rotate(0.1deg) scale(1.01);
        }
        50% {
          transform: rotate(0.8deg) scale(1.05);
        }
        100% {
          transform: rotate(1.6deg) scale(1.1);
        }
      }
    }

  }
</style>
